






















































































import {
  computed,
  defineComponent,
  PropType,
  watch,
  ref
} from '~/utils/nuxt3-migration'
import { MobileMenuItem } from '~/models/header/mobile-menu'
import { ciAngleRight } from '~/icons/source/regular/angle-right'
import MobileMenuEntry from './MobileMenuEntry.vue'
import QuickSearchCategoryMenu from '~/components/car/classifieds/quick-search/QuickSearchCategoryMenu.vue'

export default defineComponent({
  components: {
    QuickSearchCategoryMenu,
    MobileMenuEntry
  },
  name: 'MobileMenuEntry',
  props: {
    menu: {
      type: Object as PropType<MobileMenuItem>,
      required: true
    },
    selectedMenus: {
      type: Array as PropType<string[]>,
      required: true
    },
    icon: {
      type: Object,
      required: false,
      default: null
    },
    customClass: {
      type: String,
      required: false,
      default: ''
    },
    clickFunction: {
      type: Function,
      required: true
    },
    navigateFunction: {
      type: Function,
      required: false,
      default: null
    },
    topOffset: {
      type: Number,
      default: 0
    },
    transitioning: {
      type: Boolean,
      default: false
    },
    paddingClass: {
      type: String,
      default: 'tw-p-4'
    }
  },
  setup(props, { slots }) {
    const menuEntryClasses =
      'tw-flex tw-gap-3 tw-items-center tw-h-[48px] tw-px-2 tw-text-grey-900 tw-text-lg tw-font-medium tw-min-w-0 tw-w-full'
    const menuTitleClasses =
      'tw-text-lg tw-whitespace-nowrap tw-text-ellipsis tw-overflow-hidden'

    const submenuRef = ref(null)

    const hasSubmenu = computed(() => {
      return Boolean(
        props.menu.subLinks?.length ||
          props.menu.hasFetchableSubLinks ||
          slots.submenu
      )
    })

    const checkboxId = computed(() => {
      return `sub-${props.menu.key}`
    })

    const isSelected = computed(() => {
      return props.selectedMenus.some(m => m === checkboxId.value)
    })

    const isLastSelected = computed(() => {
      if (props.selectedMenus.length) {
        return (
          props.selectedMenus[props.selectedMenus.length - 1] ===
          checkboxId.value
        )
      }
      return false
    })

    watch(isLastSelected, (val, oldVal) => {
      if (!val && oldVal && submenuRef.value) {
        // was last but no longer is so lets scroll back to top
        setTimeout(() => {
          if (submenuRef.value) {
            submenuRef.value.scrollTop = 0
          }
        }, 150)
      }
    })

    const useNavigateFunction = computed(() => {
      return props.menu.useNuxtLink && props.menu.link && props.navigateFunction
    })

    return {
      hasSubmenu,
      checkboxId,
      isSelected,
      menuEntryClasses,
      menuTitleClasses,
      ciAngleRight,
      submenuRef,
      isLastSelected,
      useNavigateFunction
    }
  }
})
